import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  Grid,
} from "@mui/material";
import { AddCircle, Add } from "@mui/icons-material";
import { BACKGROUND_COLORS, TEXT_COLORS, CONTROL_ORO_COLORS } from "../../style/colors.js";
import { ktValues } from "../../constants/Constants";

export default function ComponentControlOro() {
  const [tablesData, setTablesData] = useState({});
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState([
    {
      fecha: "",
      descripcion: "",
      documento: "",
      entrada: "",
      salida: "",
      saldo: "",
    },
    {
      fecha: "",
      descripcion: "",
      documento: "",
      entrada: "",
      salida: "",
      saldo: "",
    },
    {
      fecha: "",
      descripcion: "",
      documento: "",
      entrada: "",
      salida: "",
      saldo: "",
    },
    {
      fecha: "",
      descripcion: "",
      documento: "",
      entrada: "",
      salida: "",
      saldo: "",
    },
    {
      fecha: "",
      descripcion: "",
      documento: "",
      entrada: "",
      salida: "",
      saldo: "",
    },
    {
      fecha: "",
      descripcion: "",
      documento: "",
      entrada: "",
      salida: "",
      saldo: "",
    },
    {
      fecha: "",
      descripcion: "",
      documento: "",
      entrada: "",
      salida: "",
      saldo: "",
    },
  ]);
  const [totals, setTotals] = useState({
    fino18kt: 0,
    fino950kt: 0,
    fino925kt: 0,
  });

  const handleAddRow = () => {
    setFormData([
      ...formData,
      {
        fecha: "",
        descripcion: "",
        documento: "",
        entrada: "",
        salida: "",
        saldo: "",
      },
    ]);
  };

  useEffect(() => {
    if (!tablesData.original) return;

    let total18kt = 800;
    let total950kt = 500;
    let total925kt = 900;

    setTotals({
      fino18kt: total18kt.toFixed(2),
      fino950kt: total950kt.toFixed(2),
      fino925kt: total925kt.toFixed(2),
    });
  }, [tablesData]);

  const handleInputChange = (index, field, value) => {
    const updatedData = [...formData];
    updatedData[index][field] = value;

    if (field === "entrada" || field === "salida") {
      const prevSaldo =
        index === 0 ? 0 : parseFloat(updatedData[index - 1].saldo || 0);
      const entrada = parseFloat(updatedData[index].entrada || 0);
      const salida = parseFloat(updatedData[index].salida || 0);
      updatedData[index].saldo = (prevSaldo + entrada - salida).toFixed(2);
    }

    setFormData(updatedData);
  };

  const handleSubmit = () => {
    console.log("Datos enviados:", formData);
  };

  useEffect(() => {
    const sampleData = {
      original: [
        {
          fecha: "25/11/2024",
          tipo: "OB 18KT GENIA 176",
          departamento: "Fundición",
          descripcion: "Fundición",
          documento: "MO--5046-01",
          Kt: "18",
          Ct: "",
          Fornitura: "",
          entrada: "15,26",
          salida: "0,00",
          saldo: "15,26",
        },
        {
          fecha: "25/11/2024",
          tipo: "Platino",
          departamento: "Fundición",
          descripcion: "Fundición",
          documento: "MO--5046-01",
          Kt: "950",
          Ct: "",
          Fornitura: "",
          entrada: "365.49",
          salida: "0,00",
          saldo: "365.49",
        },
        {
          fecha: "25/11/2024",
          tipo: "OB 18KT GENIA 176",
          departamento: "Fundición",
          descripcion: "Fundición",
          documento: "MO--5046-01",
          Kt: "18",
          Ct: "",
          Fornitura: "",
          entrada: "15,26",
          salida: "0,00",
          saldo: "15,26",
        },
        {
          fecha: "25/11/2024",
          tipo: "Plata",
          departamento: "Fundición",
          descripcion: "Fundición",
          documento: "MO--5046-01",
          Kt: "925",
          Ct: "",
          Fornitura: "",
          entrada: "15,26",
          salida: "0,00",
          saldo: "15,26",
        },
      ],
    };
    setTablesData(sampleData);
  }, []);

  const renderTable = (title, data) => (
    <Box sx={{ width: "100%" }}>
      <Typography
        sx={{
          textAlign: "center",
          fontWeight: "bold",
          fontFamily: "monospace",
        }}>
        {title}
      </Typography>
      <TableContainer
        component={Paper}
        sx={{ maxHeight: "65vh", overflow: "auto" }}>
        <Table size='small' stickyHeader>
          <TableHead>
            <TableRow>
              {[
                "Fecha",
                "Tipo",
                "Departamento",
                "Comentario",
                "Documento",
                "Kt",
                "Ct",
                "Fornitura",
                "Entrada",
                "Salida",
                "Saldo",
              ].map((title) => (
                <TableCell
                  key={title}
                  sx={{
                    backgroundColor: BACKGROUND_COLORS.TABLE_HEADER,
                    fontWeight: "bold",
                    textAlign: "center",
                  }}>
                  {title}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {data.map((row, index) => (
              <TableRow key={index}>
                <TableCell align='center'>{row.fecha}</TableCell>
                <TableCell align='center'>{row.tipo}</TableCell>
                <TableCell align='center'>{row.departamento}</TableCell>
                <TableCell align='center'>{row.comentario}</TableCell>
                <TableCell align='center'>{row.documento}</TableCell>
                <TableCell align='center'>{row.Kt}</TableCell>
                <TableCell align='center'>{row.Ct}</TableCell>
                <TableCell align='center'>{row.Fornitura}</TableCell>
                <TableCell align='center'>{row.entrada}</TableCell>
                <TableCell align='center'>{row.salida}</TableCell>
                <TableCell align='center'>{row.saldo}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );

  return (
    <Box sx={{ padding: 2, marginTop: -4 }}>
      <Box sx={{ display: "flex", justifyContent: "flex-end", marginTop: 1 }}>
        <Box sx={{ display: "flex", gap: 1, marginRight: 3 }}>
          <Typography
            sx={{
              // fontWeight: "bold",
              fontSize: "14px",
              backgroundColor: CONTROL_ORO_COLORS.BACKGROUND_SUBTLE, // Color de fondo más sutil
              color: TEXT_COLORS.DARK,
              padding: "6px ",
              margin: "5px",
              borderRadius: "8px",
              minWidth: "120px",
              textAlign: "center",
            }}>
            Fino 18kt: {totals.fino18kt} g
          </Typography>
          <Typography
            sx={{
              // fontWeight: "bold",
              fontSize: "14px",
              backgroundColor: CONTROL_ORO_COLORS.BACKGROUND_SUBTLE,
              color: TEXT_COLORS.DARK,
              padding: "6px",
              margin: "5px",
              borderRadius: "8px",
              minWidth: "120px",
              textAlign: "center",
            }}>
            Fino 950kt: {totals.fino950kt} g
          </Typography>
          <Typography
            sx={{
              // fontWeight: "bold",
              fontSize: "14px",
              backgroundColor: CONTROL_ORO_COLORS.BACKGROUND_SUBTLE,
              color: TEXT_COLORS.DARK,
              padding: "6px",
              margin: "5px",
              borderRadius: "8px",
              minWidth: "120px",
              textAlign: "center",
            }}>
            Fino 925kt: {totals.fino925kt} g
          </Typography>
        </Box>

        <IconButton
          onClick={() => setOpen(true)}
          sx={{
            color: BACKGROUND_COLORS.PRIMARY,
          }}>
          <AddCircle fontSize='medium' />
        </IconButton>
      </Box>

      <Grid
        container
        spacing={2}
        sx={{ display: "flex", justifyContent: "flex-end", marginTop: -5 }}>
        <Grid item xs={12}>
          {renderTable("OB 18KT GENIA 176 original", tablesData.original || [])}
        </Grid>
      </Grid>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth='lg'
        fullWidth>
        <DialogTitle>Agregar Datos</DialogTitle>
        <DialogContent>
          <TableContainer component={Paper}>
            <Table size='small'>
              <TableHead>
                <TableRow>
                  {[
                    "Fecha",
                    "Descripción",
                    "Documento",
                    "Entrada",
                    "Salida",
                    "Saldo",
                  ].map((title) => (
                    <TableCell
                      key={title}
                      sx={{
                        backgroundColor: BACKGROUND_COLORS.TABLE_HEADER,
                        fontWeight: "bold",
                        textAlign: "center",
                      }}>
                      {title}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {formData.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <TextField
                        type='date'
                        value={row.fecha}
                        onChange={(e) =>
                          handleInputChange(index, "fecha", e.target.value)
                        }
                        variant='standard'
                        size='small'
                        sx={{ width: "100%", padding: "4px", margin: "0px" }}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        value={row.descripcion}
                        onChange={(e) =>
                          handleInputChange(
                            index,
                            "descripcion",
                            e.target.value
                          )
                        }
                        variant='standard'
                        size='small'
                        sx={{ width: "100%", padding: "4px", margin: "0px" }}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        value={row.documento}
                        onChange={(e) =>
                          handleInputChange(index, "documento", e.target.value)
                        }
                        variant='standard'
                        size='small'
                        sx={{ width: "100%", padding: "4px", margin: "0px" }}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        type='number'
                        value={row.entrada}
                        onChange={(e) =>
                          handleInputChange(index, "entrada", e.target.value)
                        }
                        variant='standard'
                        size='small'
                        sx={{ width: "100%", padding: "4px", margin: "0px" }}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        type='number'
                        value={row.salida}
                        onChange={(e) =>
                          handleInputChange(index, "salida", e.target.value)
                        }
                        variant='standard'
                        size='small'
                        sx={{ width: "100%", padding: "4px", margin: "0px" }}
                      />
                    </TableCell>
                    <TableCell>{row.saldo}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
            {/* Botón para agregar fila */}
            <IconButton onClick={handleAddRow} color='primary'>
              <AddCircle fontSize='large' />
            </IconButton>

            {/* Botón de enviar alineado a la derecha */}
            <Button
              variant='contained'
              color='primary'
              onClick={handleSubmit}
              sx={{ textTransform: "none" }}>
              Enviar
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
